import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { computed } from "vue";
import { getAppRoot } from "@/onload";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ErrorMessages',
    props: {
        messages: null
    },
    emits: ["dismissed"],
    setup(__props, { emit }) {
        const props = __props;
        const loginLink = computed(() => `${getAppRoot()}login?redirect=${encodeURIComponent(window.location.toString())}`);
        function hasLogin(string) {
            return string.includes("logged in");
        }
        function splitLoginString(string) {
            return string.split(/(logged in)/g);
        }
        return { __sfc: true, props, emit, loginLink, hasLogin, splitLoginString, BAlert };
    }
});
